<template>
  <div class="majorProportion">
    <div v-for="(item,index) in chartList" :key="index" class="index">
      <div class="statusCount" :id="item.id"/>
    </div>
  </div>
</template>

<script>
import projectHome from "@/xgzdService/projectHome-service";
import { mapState } from "vuex";
import * as echarts from 'echarts';
export default {
  data(){
    return{
      statusCountList:[],
      chartList:[],
      HardDisklength: 0
    }
  },
  computed:{
    ...mapState({
      prjInfo: state => state.projectMg.prjObj,
    }),
  },
  created(){
    this.getStatusCount();
  },
  methods:{
    async getStatusCount(){
      const { prjId }=this.prjInfo;
      const { data }=await projectHome.statusCount(prjId);
      this.statusCountList= data.map((item)=>{
        return{
          id:item.id,
          name:item.name,
          num:item.num,
          proportion:this.getPercent(item.num,item.totalNum)
        }
      });
      this.init()
    },
    init(){
      let alist = [];
      let blist = [];
      let clist = [];
      let arr = [];
      this.HardDisklength = this.statusCountList.length;
      for (let i = 0; i <this.statusCountList.length; i++) {
        let item = {
          barChart: '', // chart 对象实例
          id: this.statusCountList[i].id, // 为了标示 id 不同
        }
        arr.push(item);
        alist.push(this.statusCountList[i].num);
        blist.push(this.statusCountList[i].name);
        clist.push(this.statusCountList[i].proportion);
      }
      this.chartList = arr;
      this.$nextTick(() => {
        for (let i = 0; i < this.chartList.length; i++) {
          this.chartList[i].barChart = echarts.init(document.getElementById(this.chartList[i].id));
          this.chartList[i].barChart.setOption(this.HardDiskOption(alist[i], blist[i] , clist[i])); //设置option
          window.onresize = this.chartList[i].barChart.resize;
        }
      })
    },
    HardDiskOption(a, b , c) {
      return {
        tooltip: {
          trigger: "item",
          backgroundColor: "rgba(0, 0, 0, 0.62)",
          textStyle: {
            fontFamily: "PingFang SC",
            fontSize: 14,
            color: "#ffffff"
          },
          formatter(e) {
            return (
              e.marker +
              " " +
              b +
              "<br>" +
              "&nbsp;&nbsp;&nbsp;&nbsp;" +
              "问题数：" +
              a +
              "<br>" +
              "&nbsp;&nbsp;&nbsp;&nbsp;" +
              "占比：" +
              c +
              "%"
            );
          }
        },
        graphic: [
          {
            //图形中间文字
            type: "text",
            left: "center",
            top: "45%",
            style: {
              text: b,
              textAlign: "top",
              fill: "#666666",
              fontSize: 15
            }
          },
          {
            type: "text",
            left: "center",
            top: "53%",
            style: {
              text:  c +"%",
              textAlign: "top",
              fill: "#33333",
              fontSize: 16
            }
          },
        ],
        color: ['#5587F0',"#F0F2F5"],
        series: [{
          name: 'Line 1',
          type: 'pie',
          clockWise: true,
          radius: ["50%", "70%"],
          center: ["50%", "50%"],
          itemStyle: {
            normal: {
              label: {
                show: false
              },
              labelLine: {
                show: false
              }
            }
          },
          hoverAnimation: false,
          data: [{
            value: c,
            name: '01',
            itemStyle: {
              normal: {
                label: {
                  show: false
                },
                labelLine: {
                  show: false
                }
              }
            }
          }, {
            name: '02',
            value: 100-c
          }]
        }]
      }
    },
    getPercent(num, total){
      num = parseFloat(num);
      total = parseFloat(total);
      if (isNaN(num) || isNaN(total)) {
        return "-";
      }
      return total <= 0? 0 : Math.round((num / total) * 10000) / 100.0;
    },
  }
}
</script>

<style lang="scss" scoped>
.majorProportion{
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: space-around;
  overflow: auto;
  .index{
    height: 100%;
     width: 100%;
    .statusCount{
      width: 100%;
      height: 100%;
    }
  }
}
</style>
